// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: the store-reading side of SidebarPages. Everything that asks "which
// pages does this person have" (the sidebar, the avatar pop-up's More, the
// Settings list, "Open Konvo on", the phone rail) reads the same live inputs
// from here. Read inside an observer to stay live.

import type {
	DesktopSidebarPrefs,
	SidebarPageConditions,
} from '@app/features/app/components/layout/sidebar_nav/SidebarPages';
import RuntimeConfig from '@app/features/app/state/RuntimeConfig';
import AgentsAccess from '@app/features/konvo_agents/state/AgentsAccess';
import KonvoCalendarPrefs from '@app/features/konvo_calendar/state/KonvoCalendarPrefs';
import KonvoWhatsApp from '@app/features/konvo_whatsapp/state/KonvoWhatsApp';

/** Coding agents are switched on per person (Team insights rollout). */
export function isAgentsEnabled(): boolean {
	return AgentsAccess.enabled;
}

export interface SidebarConditionOverrides {
	/** At launch the link and access states are not known yet; treat them as on so a saved choice holds. */
	assumeConnected?: boolean;
}

export function currentSidebarPageConditions(overrides: SidebarConditionOverrides = {}): SidebarPageConditions {
	return {
		directMessagesDisabled: RuntimeConfig.directMessagesDisabled,
		whatsappLinked: overrides.assumeConnected === true || KonvoWhatsApp.linked,
		agentsEnabled: overrides.assumeConnected === true || isAgentsEnabled(),
	};
}

/** The account-synced order and hidden set (cached locally, so it is right at boot). */
export function currentDesktopSidebar(): DesktopSidebarPrefs {
	return KonvoCalendarPrefs.desktopSidebar;
}
